import { HTMLSelect, Label } from "@blueprintjs/core";
import * as React from "react";

export const SelectLotNumber = ({
  lotNumbers,
  value,
  onChange,
}: {
  value: number;
  onChange: (newValue: number) => void;
  lotNumbers: string[];
}) => {
  const lotNumberOptions = [];
  for (let i = 0; i < lotNumbers.length; ++i) {
    lotNumberOptions.push({ value: i, label: `${lotNumbers[i]}` });
  }

  return (
    <Label className="select-lot-number">
      <span>Lot Number</span>
      <HTMLSelect
        value={value}
        options={lotNumberOptions}
        onChange={(event) => onChange(parseInt(event.target.value, 10))}
      />
    </Label>
  );
};
